import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { CreateUserActivityParams } from '../UserActivity.meta';

const createUserActivity = async ({ clientId, activity }: CreateUserActivityParams) => {
  return authFetch(`/Consumer/ActivityLog/SaveActivity?clientId=${clientId}`, {
    method: 'POST',
    ...httpBodyOptions(activity, true),
  });
};

export const useCreateUserActivityMutation = () => {
  return useMutation(createUserActivity);
};
